<kendo-drawer-container class="drawer-container">
  <kendo-drawer
    #infoDrawer
    mode="push"
    position="end"
    [mini]="true"
    [miniWidth]="56"
    [width]="300"
    [expanded]="true"
    [autoCollapse]="true"
    class="journal-currencies-info-drawer"
  >
    <ng-template kendoDrawerTemplate>
      <form [formGroup]="form" class="flex flex-col p-5 m-0">
        <div class="drawer-account-card">
          @if (showBaseAmount() || allowDualCurrency) {
            <div class="flex flex-col gap-3">
              @if (showBaseAmount()) {
                <div>
                  <kendo-formfield>
                    <kendo-label [text]="baseCurrency1 + ' Amount'">
                      <kendo-numerictextbox
                        formControlName="baseAmount1"
                        [spinners]="false"
                        [min]="0"
                        [decimals]="2"
                        [maxlength]="16"
                        [autoCorrect]="true"
                        (valueChange)="onChangeBaseAmount1($event)"
                      ></kendo-numerictextbox>
                    </kendo-label>
                  </kendo-formfield>
                </div>
              }
              @if (allowDualCurrency) {
                <div>
                  <kendo-formfield>
                    <kendo-label [text]="baseCurrency2 + ' Amount'">
                      <kendo-numerictextbox
                        formControlName="baseAmount2"
                        [spinners]="false"
                        [min]="0"
                        [decimals]="2"
                        [maxlength]="16"
                        [autoCorrect]="true"
                        (valueChange)="onChangeBaseAmount2($event)"
                      ></kendo-numerictextbox>
                    </kendo-label>
                  </kendo-formfield>
                </div>
              }
              @if (allowDualCurrency) {
                <div>
                  <kendo-formfield>
                    <kendo-label text="Parity Rate">
                      <kendo-numerictextbox
                        formControlName="parityRate"
                        [spinners]="false"
                        [min]="0"
                        [decimals]="4"
                        [maxlength]="32"
                        [autoCorrect]="true"
                        [format]="rateFormatOptions"
                        (valueChange)="onChangeParityRate($event)"
                      ></kendo-numerictextbox>
                    </kendo-label>
                  </kendo-formfield>
                </div>
              }
              @if (!allowDualCurrency && showBaseAmount()) {
                <div>
                  <kendo-formfield>
                    <kendo-label text="Currency Rate">
                      <kendo-numerictextbox
                        formControlName="currencyRate"
                        [spinners]="false"
                        [min]="0"
                        [decimals]="4"
                        [maxlength]="32"
                        [autoCorrect]="true"
                        [format]="rateFormatOptions"
                      ></kendo-numerictextbox>
                    </kendo-label>
                  </kendo-formfield>
                </div>
              }
            </div>
          }
          @if (showAmountAndCurrencyRate()) {
            <div class="flex flex-col gap-3">
              <div class="flex flex-row">
                <p class="flex basis-1/2 mt-0">
                  <b>{{ "amount" | translate }}</b>
                </p>
                <div class="flex basis-1/2 justify-end mr-3">
                  <app-currency-total
                    [currencyUid]="data?.currencyUid"
                    [totalAmount]="data?.amount"
                  ></app-currency-total>
                </div>
              </div>
              <div>
                <kendo-formfield>
                  <kendo-label text="Currency Rate">
                    <kendo-numerictextbox
                      formControlName="currencyRate"
                      [spinners]="false"
                      [min]="0"
                      [decimals]="4"
                      [maxlength]="32"
                      [autoCorrect]="true"
                      [format]="rateFormatOptions"
                    ></kendo-numerictextbox>
                  </kendo-label>
                </kendo-formfield>
              </div>
            </div>
          }
        </div>

        @if (data?.accountDetails?.fullName) {
          <div class="drawer-account-card mt-4">
            <h4 class="drawer-account-card__title">
              {{ "accountInformation" | translate }}
            </h4>
            <div class="drawer-account-card__divider"></div>
            <div class="drawer-account-card__rows">
              <div class="drawer-account-card__row">
                <span class="drawer-account-card__label">{{
                  "rootType" | translate
                }}</span>
                <span class="drawer-account-card__value">
                  {{ data.accountDetails?.accountRootType }}
                </span>
              </div>
              <div class="drawer-account-card__row">
                <span class="drawer-account-card__label">{{
                  "type" | translate
                }}</span>
                <span class="drawer-account-card__value">{{
                  data.accountDetails?.accountType
                }}</span>
              </div>
              <div class="drawer-account-card__row">
                <span class="drawer-account-card__label">{{
                  "subType" | translate
                }}</span>
                <span class="drawer-account-card__value">
                  {{ data.accountDetails?.accountSubType }}
                </span>
              </div>
              <div
                class="drawer-account-card__row drawer-account-card__row--multiline"
              >
                <span class="drawer-account-card__label">{{
                  "name" | translate
                }}</span>
                <span
                  class="drawer-account-card__value drawer-account-card__value--multiline"
                >
                  {{ data.accountDetails.fullName }}
                </span>
              </div>
            </div>
          </div>
        }
        @if (mode !== "view") {
          <div class="drawer-balance-card mt-4">
            <h4 class="drawer-balance-card__title">
              {{ "currencyInfo" | translate }}
            </h4>

            <div class="drawer-balance-card__group">
              <div class="drawer-balance-card__row">
                <span class="drawer-balance-card__label"
                  >{{ baseCurrency1 }} {{ "amount" | translate }}</span
                >
                <span class="drawer-balance-card__value">{{
                  data?.baseAmount1 | number: "1.2-2"
                }}</span>
              </div>
              @if (allowDualCurrency) {
                <div class="drawer-balance-card__row">
                  <span class="drawer-balance-card__label"
                    >{{ baseCurrency2 }} {{ "amount" | translate }}</span
                  >
                  <span class="drawer-balance-card__value">{{
                    data?.baseAmount2 | number: "1.2-2"
                  }}</span>
                </div>
              }
              <div class="drawer-balance-card__row">
                <span class="drawer-balance-card__label">Currency Rate</span>
                <span class="drawer-balance-card__value">{{
                  data?.currencyRate | number: "1.0-4"
                }}</span>
              </div>
            </div>

            <div class="drawer-balance-card__divider"></div>

            <h4 class="drawer-balance-card__subtitle">Balance Summary</h4>
            <div class="drawer-balance-card__row">
              <span class="drawer-balance-card__label">Debit</span>
              <span
                class="drawer-balance-card__value drawer-balance-card__value--debit"
              >
                {{ data?.unbalancedDebit | number: "1.2-2" }}
              </span>
            </div>
            <div
              class="drawer-balance-card__divider drawer-balance-card__divider--compact"
            ></div>
            <div class="drawer-balance-card__row">
              <span class="drawer-balance-card__label">Credit</span>
              <span
                class="drawer-balance-card__value drawer-balance-card__value--credit"
              >
                {{ data?.unbalancedCredit | number: "1.2-2" }}
              </span>
            </div>
            @if (allowDualCurrency) {
              <div class="drawer-balance-card__row">
                <span class="drawer-balance-card__label"
                  >{{ baseCurrency2 }} Debit</span
                >
                <span
                  class="drawer-balance-card__value drawer-balance-card__value--debit"
                >
                  {{ data?.unbalancedDebit2 | number: "1.2-2" }}
                </span>
              </div>
              <div class="drawer-balance-card__row">
                <span class="drawer-balance-card__label"
                  >{{ baseCurrency2 }} Credit</span
                >
                <span
                  class="drawer-balance-card__value drawer-balance-card__value--credit"
                >
                  {{ data?.unbalancedCredit2 | number: "1.2-2" }}
                </span>
              </div>
            }
          </div>
        }
        @if (allowDualCurrency && mode !== "view") {
          <div class="mt-5">
            <div class="footer flex flex-row justify-center">
              <button
                kendoButton
                [disabled]="!hasUnbalancedSides()"
                class="btn btn-outline-primary"
                (click)="onClickAddBalancingRow()"
              >
                {{ "addBalancingRow" | translate }}
              </button>
            </div>
          </div>
        }
      </form>
    </ng-template>
  </kendo-drawer>

  <kendo-drawer-content class="journal-currencies-info-drawer-content">
    <ng-content></ng-content>
  </kendo-drawer-content>
</kendo-drawer-container>
